export default "__VITE_ASSET__f0ef3b2c__"